import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType } from 'redux-observable';
import { delay, filter, mergeMap } from 'rxjs/operators';
import * as subscriptions from '@webapp/sdk/subscriptions';
import { CREATE_SUBSCRIPTION_SUCCESS } from '../actions';
import {
  GetSubscriptionSuccess,
  GetSubscriptionError,
  CreateSubscriptionSuccess,
} from '../action-creators';

export const getSubscriptionAfterCreatedEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, CreateSubscriptionSuccess>(CREATE_SUBSCRIPTION_SUCCESS),
    filter(
      (action) =>
        action.newSubscription.plan.toLowerCase() !== 'beginner' &&
        action.subscriptionType !== 'record-label'
    ),
    delay(500),
    mergeMap(async (action) => {
      try {
        const subscription = await subscriptions.get(
          action.newSubscription.clientId
        );

        return new GetSubscriptionSuccess(subscription);
      } catch (err) {
        return new GetSubscriptionError(err.message);
      }
    })
  );
